import React from 'react';
import { useTheme, makeStyles, Chip } from '@material-ui/core';
import { Whatshot } from '@material-ui/icons';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { styles } from './commodityFilter.styles';
import { EnumCommodity } from '../../../api';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

export interface CommodityFilterProps {
  commodities: CommodityFilterChoice[];
  commodity: EnumCommodity;
  onSelectCommodity: (initCommodity: EnumCommodity, commodityFilter?: EnumCommodity) => void;
  enabled?: boolean;
  inactive?: boolean;
}

export interface CommodityFilterChoice {
  commodity: EnumCommodity;
  label?: string;
  // icon?: JSX.Element;
}

const CommodityFilter: React.FC<CommodityFilterProps> = ({
  commodities,
  commodity,
  onSelectCommodity,
  enabled = true,
  inactive = false
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'enums']);
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  const [activeFilter, setActiveFilter] = React.useState<EnumCommodity>(commodity);

  const commodityFilterChange = React.useCallback(
    (commodity: EnumCommodity) => {
      setActiveFilter(commodity);
      onSelectCommodity(commodity);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeFilter]
  );

  const getFilterLabel = (commodityFilter: CommodityFilterChoice) => {
    switch (commodityFilter.commodity) {
      case EnumCommodity.GasNatural:
        return commodityFilter.label ?? t('translation:components.commodityFilter.naturalGas');
      case EnumCommodity.Electricidad:
        return commodityFilter.label ?? t('translation:components.commodityFilter.power');
      default:
        return commodityFilter.label;
    }
  };

  const getFilterIcon = (commodityFilter: CommodityFilterChoice) => {
    switch (commodityFilter.commodity) {
      case EnumCommodity.GasNatural:
        return <Whatshot />;
      case EnumCommodity.Electricidad:
        return <EmojiObjectsIcon />;
      default:
        return;
    }
  };

  return (
    <>
      <div className={classes.filters}>
        {commodities.map((commodity, index) => (
          <Chip
            size="small"
            variant={enabled ? 'default' : 'outlined'}
            key={index}
            className={clsx(classes.filter, { [classes.filterDisabled]: !enabled })}
            label={getFilterLabel(commodity)}
            icon={getFilterIcon(commodity)}
            color={!inactive && commodity.commodity === activeFilter ? 'primary' : 'default'}
            clickable={enabled}
            onClick={() => {
              enabled && commodityFilterChange(commodity.commodity);
            }}
          />
        ))}
      </div>
    </>
  );
};

export default React.memo(CommodityFilter);
